import axios from "axios";

export default axios.create({
    baseURL: process.env.REACT_APP_RECRUITMENT_BACKEND_BASE_URL,
    headers: { 'Content-Type': 'application/json',
          //'ngrok-skip-browser-warning': '69240'
     },
})